import { render, staticRenderFns } from "./ItsOrderDepartRawDetail.vue?vue&type=template&id=5c5f1a55&scoped=true&"
import script from "./ItsOrderDepartRawDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderDepartRawDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderDepartRawDetail.vue?vue&type=style&index=0&id=5c5f1a55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f1a55",
  null
  
)

export default component.exports